<div class="units-wrapper">
    <ev-grid-table [gridModel]="displayTemplate">
        <ev-th>
            <ev-td class="spacing-left" area="spacingLeft"></ev-td>

            @for(column of headers; track column.name) {
                @if(column?.isSortable) {
                    <ev-td
                    [area]="column.prop"
                    (click)="updateSort(column.prop)"
                    [isSelectable]="true"
                    [textAlignment]="column.textAlignment ?? 'left'"
                    [selected]="sortConfig().sortOption.prop == column.prop">
                        {{column.name.toUpperCase()}}
                    </ev-td>
                } 
                @else {
                    <ev-td [area]="column.prop" [textAlignment]="column.textAlignment ?? 'left'">
                        {{column.name.toUpperCase()}}
                    </ev-td>
                }
            }
        </ev-th>

        @if (tableData()) {
            @for(rowData of tableData(); track rowData.functionalUnitID) {
                <ev-tr class="ev-row" [hasRowContent]="false">
                    <ev-td
                        area="spacingLeft"
                        class="spacing-left"
                        header="" 
                        column
                        title="">
                        <div class="column-data"></div>
                    </ev-td>
                    <ev-td
                        area="functionalUnitNumber" 
                        header="Bruksenhetsnummer" 
                        column 
                        title="Bruksenhetsnummer"
                        [fontBold]="sortConfig().sortOption.prop == 'functionalUnitNumber'">
                        <div class="column-data">{{rowData.functionalUnitNumber | defaultconvert: "0"}}</div>
                    </ev-td>
                    <ev-td 
                        area="functionalUnitID" 
                        header="BruksenhetId" 
                        column 
                        title="BruksenhetId"
                        [fontBold]="sortConfig().sortOption.prop == 'functionalUnitID'">
                        <div class="column-data">{{rowData.functionalUnitID | defaultconvert: "0"}}</div>
                    </ev-td>
                    <ev-td 
                        area="functionalUnitTypeName" 
                        header="BruksenhetsType"
                        column 
                        title="BruksenhetsType"
                        [fontBold]="sortConfig().sortOption.prop == 'functionalUnitTypeName'">
                        <div class="column-data">{{rowData.functionalUnitTypeName | defaultconvert: "-"}}</div>
                    </ev-td>
                    <ev-td 
                        area="usableArea" 
                        header="BRA" 
                        column 
                        title="BRA"
                        textAlignment="right"
                        [fontBold]="sortConfig().sortOption.prop == 'usableArea'">
                        <div class="column-data">{{rowData.usableArea | thousandize | defaultconvert: "0"}} {{rowData.usableArea ? 'm²' : ''}}</div>
                    </ev-td>
                    <ev-td 
                        area="rooms" 
                        header="Rom" 
                        column 
                        title="Rom"
                        textAlignment="right"
                        [fontBold]="sortConfig().sortOption.prop == 'rooms'">
                        <div class="column-data">{{rowData.rooms | thousandize | defaultconvert: "0"}}</div>
                    </ev-td>
                    <ev-td 
                        area="baths" 
                        header="Baderom" 
                        column 
                        title="Baderom"
                        textAlignment="right"
                        [fontBold]="sortConfig().sortOption.prop == 'baths'">
                        <div class="column-data">{{rowData.baths | thousandize | defaultconvert: "0"}}</div>
                    </ev-td>
                    <ev-td 
                        area="kitchenCode" 
                        header="Kjøkken" 
                        column 
                        title="Kjøkken"
                        textAlignment="right"
                        [fontBold]="sortConfig().sortOption.prop == 'kitchenCode'">
                        <div class="column-data">{{rowData.kitchenCode | defaultconvert: "-"}}</div>
                    </ev-td>
                    <ev-td 
                        area="toilets" 
                        header="WC" 
                        column 
                        title="WC"
                        textAlignment="right"
                        [fontBold]="sortConfig().sortOption.prop == 'toilets'">
                        <div class="column-data">{{rowData.toilets | thousandize | defaultconvert: "0"}}</div>
                    </ev-td>
                </ev-tr>
            }
        }
    </ev-grid-table>

    @if(originalData().length > rowsToShow) {
        <div class="show-more-button">
            <button (click)="onShowMore()">Vis flere</button>
        </div>
    }
</div>